export const environment = {
  version: '1.1.28D',
  production: false,
  captchaSVK: '6Le-etEUAAAAAG11VOp7m9XydFcEsBaVe2ePw2pR',
  aternaServiceEmisionConciliacion: 'https://aterna-ingress-dev.gc.gentera.com.mx/api/emisionback/v1/',
  aternaServiceSiniestros: 'https://aterna-ingress-dev.gc.gentera.com.mx/api/emisionback/v1/',
  key_map:'AIzaSyCpVhQiwAllg1RAFaxMWSpQruuGARy0Y1k',
  services: {
    catCausaSiniestro: 'https://ent-platf-emision-back-go-tzcgryu3iq-ue.a.run.app/api/v1/emisionback/',
    catCamposSiniestroExpress: 'https://ent-platf-emision-back-go-tzcgryu3iq-ue.a.run.app/api/v1/emisionback/express/'
  },
  pathService:{
    login:'login',
    refresh_token: 'refresh_token'
  }
};
